import styled from 'styled-components';

export const SpinnerWrapperStyled = styled.div`
  width: 1.6rem;
  height: 1.6rem;
`;
